// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sell-menu[data-v-3b0a5aae]{display:flex;flex-wrap:nowrap;overflow-x:auto;position:absolute;top:0}.sell-menu .nav-item[data-v-3b0a5aae]{flex-shrink:0;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
